import { RecordOf } from 'immutable';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const selectFleetSettingsState = () => (state: RecordOf<RootState>) => state.get('geofences');

export const selectGeofences = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('geofences'));

export const selectLoading = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('loading'));

export const selectErrors = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('errors'));

export const selectGeofenceRules = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('geofenceRules'));
